import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';

const slice = createSlice({
	name: 'proposals',
	initialState: {
		list: null,
		loading: false,
		lastFetch: null,
		updated: false,
		searchText: '',
		noProposals: false,
	},
	reducers: {
		proposalsRequestFailed: (proposals, action) => {
			proposals.loading = false;
			proposals.noProposals = true;
		},
		proposalsRequested: (proposals, action) => {
			proposals.loading = true;
		},
		proposalsReceived: (proposals, action) => {
			proposals.list = action.payload.data;
			if (action.payload.data.length === 0) proposals.noProposals = true;
			else proposals.noProposals = false;
			proposals.loading = false;
			proposals.lastFetch = Date.now();
			proposals.updated = false;
		},
		proposalsAdded: (proposals, action) => {
			proposals?.list?.unshift(action.payload);
			proposals.updated = true;
			proposals.noProposals = false;
		},
		proposalsDeleted: (proposals, action) => {
			const index = proposals.list.findIndex(s => s.id === action.payload.deletedId);
			proposals.list[index].status = 'CANCELLED';
			proposals.updated = true;
			if (proposals.list.length === 0) proposals.noProposals = true;
		},
		proposalsUpdated: (proposals, action) => {
			const index = proposals.list.findIndex(s => s.id === action.payload.id);
			proposals.list[index] = action.payload;
			proposals.updated = true;
			proposals.noProposals = false;
		},
		searchTextChanged: (proposals, action) => {
			proposals.searchText = action.payload;
		},
		proposalsRelated: (proposals, action) => {
			proposals.updated = true;
		},
		relatedUpdated: (proposals, action) => {
			proposals.updated = false;
		},
	},
});

export const {
	proposalsAdded,
	proposalsReceived,
	proposalsRequested,
	proposalsRequestFailed,
	searchTextChanged,
	proposalsUpdated,
	proposalsDeleted,
	proposalsRelated,
	relatedUpdated,
} = slice.actions;

export const loadProposals =
	(type = 'user', page = 1, per_page = 100) =>
	(dispatch, getState) => {
		const user = getState().auth.user;

		dispatch(
			apiCallBegan({
				api: 'hammurabi',
				url: '/proposals',
				params: {
					type,
					user_id: user.id,
					page,
					per_page,
				},
				onStart: proposalsRequested.type,
				onSuccess: proposalsReceived.type,
				onError: proposalsRequestFailed.type,
			})
		);
	};

export default slice.reducer;
